import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { Mobile } from '../../../Common.styles'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'
import Banner from 'components/common/Banner/Banner'
import Popover from 'components/common/Popover'
import { formatPrice } from 'helpers/utils'
import kitIcon from '../../../assets/kit-more.png'

const Kit = ({
  className,
  kit: {
    commerceItemId,
    description,
    kitId,
    name,
    price,
    totalPrice,
    tpmsToolTipMessage,
    icon = kitIcon
  } = {},
  removeKitFromCartActionHandler,
  ...props
}) =>
  <Fragment>
    <CustomBanner className={ className } { ...props } handler={ removeKitFromCartActionHandler }>
      <KitIcon src={ icon } alt="" />
      <Wrapper>
        <Title>
          { name }
          {
            tpmsToolTipMessage &&
              <PopoverWrapper>
                <Popover>
                  <Content>{ tpmsToolTipMessage }</Content>
                </Popover>
              </PopoverWrapper>
          }
        </Title>
        <Content>{ description }</Content>
      </Wrapper>
      {
        Boolean(price) &&
          <Fragment>
            <Mobile kit>Unit Price</Mobile>
            <Price>{ formatPrice(price) }</Price>
          </Fragment>
      }
      {
        Boolean(totalPrice) &&
          <Fragment>
            <Mobile kit>Total Price</Mobile>
            <Price total>{ formatPrice(totalPrice) }</Price>
          </Fragment>
      }
    </CustomBanner>
  </Fragment>

Kit.propTypes = {
  className: PropTypes.string,
  kit: PropTypes.shape(),
  removeKitFromCartActionHandler: PropTypes.func
}

export default Kit

const CustomBanner = styled(Banner)`
  margin: 0 0 10px;
  ${Mixin.responsive('padding', '9px 20px 9px 60px', '10px')}
  ${props => props.success && css`
    border: 1px solid ${Theme.colors.light_grey};
  `}

  &:last-child {
    margin-bottom: 0;
  }

  & [data-icon] {
    display: none;
  }

  & [data-close] {
    position: absolute;
    top: 23px;
    right: 20px;
    margin: 0;
    ${Media.mobile`
      top: 10px;
      right: 10px;
    `}
  }
`

export const Image = styled.img`
  position: absolute;
  top: 50%;
  max-width: 100%;
  transform: translateY(-50%);
  ${Media.mobile`
    top: 30px;
    left: 18px;
  `}
`

export const Title = styled.div`
  display: inline-block;
  font-weight: 600;
  line-height: 19px;
  vertical-align: middle;
  color: ${Theme.colors.dark_grey};
`

export const Price = styled.span`
  display: inline-block;
  line-height: 22px;
  vertical-align: middle;
  color: ${Theme.colors.dark_grey};
  ${props => props.total && css`
    font-weight: 600;
  `}
  ${Mixin.responsive('text-align', 'right', 'left')}
  ${Mixin.responsive('width', '200px', 'calc(100% - 68px)')}
  ${Media.mobile`
    margin-top: 11px;
  `}
`

export const Content = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 17px;
  color: ${Theme.colors.dark_grey};
`

export const Wrapper = styled.div`
  ${Media.desktop`
    display: inline-block;
    vertical-align: middle;
  `}
  ${Mixin.responsive('padding', '0 15px 0 108px', '0 15px 0 66px')}
`

export const PopoverWrapper = styled.div`
  display: inline-block;
  margin-left: 8px;
  line-height: 0;
  vertical-align: middle;

  & [data-tooltip] {
    width: 14px;
    margin-right: 0;
  }
`

const KitIcon = styled(Image)`
  width: 24px;
  height: 24px;
`
